export const STRAT_STATUS = [
  { k: "decided", label: "Decided", dot: "#10B981" },
  { k: "direction", label: "Direction", dot: "#0EA5E9" },
  { k: "open", label: "Open decision", dot: "#F59E0B" },
  { k: "revisit", label: "Revisit", dot: "#EF5350" },
];
export const SSTATUS = Object.fromEntries(STRAT_STATUS.map((s) => [s.k, s]));

export const LINK_TYPE_LABEL = {
  speaker: "Speaker",
  target: "Target",
  partner: "Partner",
  session: "Session",
  experience: "Experience",
};

export const fmtDato = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("nb-NO", { day: "numeric", month: "short" });
  } catch {
    return "";
  }
};
